import Link from 'next/link';
import Head from 'next/head';
import SiteSettings from '~/siteSettings';

/**
 * Plugger Maintenance
 * @category Functional Component
 * @extends Component
 * @summary Renders as in-page maintenance message when the Plugger application is undergoing maintenance.
 *          (or when a Token is not returned).
 * @return {Node} React node containing rendered component.
 */

const PlugMaintenance = () => {
  return (
    <>
      <Head>
        <title>{ `Maintenance Mode | ${ SiteSettings.siteName }` }</title>
        <meta name='keywords' content='Maintenance Mode.' />
      </Head>
      <div className='page-error'>
        <div className='page-error-content'>
          <div>
            <h2>Maintenance Mode</h2>
            <p>These forms are undergoing maintenance. Please try again later.</p>
            <div className='spacer spacer--2'></div>
            <Link href='/'>
              <a className='btn btn--brand'>
                Go To Homepage
              </a>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default PlugMaintenance;
